import { requestStatusMapping } from '../mappings/RequestStatusMapping';

export const requestStatusOptions = Object.values(requestStatusMapping);
